// extracted by mini-css-extract-plugin
module.exports = {"button":"awsui-icon-pagination_button__4aIfN","listItem":"awsui-icon-pagination_listItem__2H1qj"};